function getLocalizedField(data, fieldBase) {
	const locale = (localStorage.getItem("my-apartmentlanguage") || "ar").replace(/"/g, "").trim().toLowerCase();
	const arValue = data[`${fieldBase}_ar`] || "";
	const enValue = data[`${fieldBase}_en`] || "";

	if (locale === "ar") {
		return arValue.length > 0 ? arValue : enValue;
	} else {
		return enValue.length > 0 ? enValue : arValue;
	}
}

export default getLocalizedField;
